import { api } from "./api";

// --- Ask Jixxeo A.I (multi-turn chat, auto-saved as Plans) ----------------
export const handsAiChat       = (message, session_id) =>
  api.post("/hands/ai/chat", { message, session_id }).then((r) => r.data);
export const handsAiPlans      = () => api.get("/hands/ai/plans").then((r) => r.data);
export const handsAiPlan       = (sid) => api.get(`/hands/ai/plans/${sid}`).then((r) => r.data);
export const handsAiPlanDelete = (sid) => api.delete(`/hands/ai/plans/${sid}`).then((r) => r.data);
export const handsAiPlanRename = (sid, title) =>
  api.patch(`/hands/ai/plans/${sid}`, { title }).then((r) => r.data);

// --- Home dashboard --------------------------------------------------------
export const handsDashboard  = () => api.get("/hands/dashboard").then((r) => r.data);

// --- Community advice board -----------------------------------------------
export const handsPosts       = (params = {}) => api.get("/hands/community/posts", { params }).then((r) => r.data);
export const handsPostCreate  = (p) => api.post("/hands/community/posts", p).then((r) => r.data);
export const handsPostUpvote  = (pid) => api.post(`/hands/community/posts/${pid}/upvote`).then((r) => r.data);
export const handsPostDelete  = (pid) => api.delete(`/hands/community/posts/${pid}`).then((r) => r.data);
export const handsComments    = (pid) => api.get(`/hands/community/posts/${pid}/comments`).then((r) => r.data);
export const handsComment     = (pid, body) => api.post(`/hands/community/posts/${pid}/comments`, { body }).then((r) => r.data);

// Admin moderation for the advice board
export const handsAdminPin      = (pid, on) => api.post(`/admin/hands/posts/${pid}/${on ? "pin" : "unpin"}`).then((r) => r.data);
export const handsAdminFeature  = (pid, on) => api.post(`/admin/hands/posts/${pid}/${on ? "feature" : "unfeature"}`).then((r) => r.data);
export const handsAdminHide     = (pid, on) => api.post(`/admin/hands/posts/${pid}/${on ? "hide" : "unhide"}`).then((r) => r.data);
export const handsAdminBanAuthor = (pid, reason) => api.post(`/admin/hands/posts/${pid}/ban-author`, { reason }).then((r) => r.data);

// --- Challenges ------------------------------------------------------------
export const handsChallenges       = () => api.get("/hands/challenges").then((r) => r.data);
export const handsChallengeJoin    = (slug) => api.post(`/hands/challenges/${slug}/join`).then((r) => r.data);
export const handsChallengeComplete= (slug) => api.post(`/hands/challenges/${slug}/complete`).then((r) => r.data);

// --- Badges ---------------------------------------------------------------
export const handsBadges = () => api.get("/hands/badges").then((r) => r.data);

export const usd = (n) => `$${(Number(n) || 0).toFixed(2)}`;
